export default __webpack_public_path__ + "static/media/ic-sort-black-24-px-opened.8e41f017.svg";